import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '2169895356748130'

function trackEvent(event: string, params?: Record<string, any>) {
  if (window.fbq) {
    if (params) {
      window.fbq('track', event, params)
    } else {
      window.fbq('track', event)
    }
  }
}

export function useMetaPixel() {
  useEffect(() => {
    // --- 1. Initialize Meta Pixel ---
    if (!window.fbq) {
      const n: any = (window.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!window._fbq) window._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const t = document.createElement('script')
      t.async = true
      t.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(t)

      // Noscript fallback
      const img = document.createElement('img')
      img.height = 1
      img.width = 1
      img.style.display = 'none'
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
      document.body.appendChild(img)

      window.fbq('init', PIXEL_ID)
    }

    // --- 2. Track PageView ---
    trackEvent('PageView')

    // --- 3. Track ViewContent when offer section is visible ---
    let viewContentFired = false
    const offerSection = document.getElementById('oferta')
    if (offerSection) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !viewContentFired) {
            viewContentFired = true
            trackEvent('ViewContent', {
              content_name: 'Reflujo Cero en 72h',
              content_category: 'Producto Digital',
              content_type: 'product',
              value: 12,
              currency: 'USD',
            })
            observer.disconnect()
          }
        },
        { threshold: 0.3 },
      )
      observer.observe(offerSection)
    }

    // --- 4. Track CTA clicks (InitiateCheckout + Lead) ---
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      const anchor = target.closest(
        'a[href], button',
      ) as HTMLAnchorElement | null
      if (!anchor) return

      const href = anchor.getAttribute('href') || ''

      // Click on #cta-final = InitiateCheckout (user scrolling to buy)
      if (href === '#cta-final') {
        trackEvent('InitiateCheckout', {
          content_name: 'Reflujo Cero en 72h',
          value: 12,
          currency: 'USD',
        })
      }

      // Click on Hotmart link = Lead + Purchase intent
      if (href.includes('pay.hotmart.com')) {
        trackEvent('Lead', {
          content_name: 'Reflujo Cero en 72h',
          value: 12,
          currency: 'USD',
        })
        trackEvent('InitiateCheckout', {
          content_name: 'Reflujo Cero en 72h',
          value: 12,
          currency: 'USD',
        })
      }
    }

    document.addEventListener('click', handleClick, true)

    // --- 5. Track scroll depth (AddToCart at 75% scroll) ---
    let addToCartFired = false
    const handleScroll = () => {
      if (addToCartFired) return
      const scrollPercent =
        (window.scrollY + window.innerHeight) /
        document.documentElement.scrollHeight
      if (scrollPercent > 0.75) {
        addToCartFired = true
        trackEvent('AddToCart', {
          content_name: 'Reflujo Cero en 72h',
          value: 12,
          currency: 'USD',
        })
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      document.removeEventListener('click', handleClick, true)
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
}
